import { render } from "./projectReview.vue?vue&type=template&id=ddae0d60&scoped=true"
import script from "./projectReview.vue?vue&type=script&lang=js"
export * from "./projectReview.vue?vue&type=script&lang=js"

import "./projectReview.vue?vue&type=style&index=0&id=ddae0d60&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddae0d60"]])

export default __exports__